import { z } from "zod";
/** Schema for a single RLS rule — discriminated union supporting force, organisation, and team rule types. */
export const RlsRuleSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("force"),
        forceId: z.uuid(),
        geographicUnitIds: z.array(z.uuid()).optional(),
    }),
    z.object({
        type: z.literal("organisation"),
        organisationIds: z.array(z.uuid()).min(1),
    }),
    z.object({
        type: z.literal("team"),
        teamIds: z.array(z.uuid()).min(1),
    }),
]);
/** Empty array means "no filtering"; null/non-array still rejected. */
export const RlsRulesSchema = z.array(RlsRuleSchema);
/** Valid with at least one RLS rule, or no rules when unfiltered access is acknowledged. */
export const EmbeddedDashboardSchema = z
    .object({
    supersetDashboardId: z.string(),
    rlsRules: RlsRulesSchema,
    noRlsAcknowledged: z.boolean().optional(),
})
    .refine((d) => d.rlsRules.length > 0 || d.noRlsAcknowledged === true, {
    message: "Set at least one RLS rule, or acknowledge no filtering",
});
/**
 * The configuration that may be set for one user in an organisation, overriding
 * the organisation's own. Each is an on/off switch, so an override is
 * tri-state: absent inherits, and an explicit true or false overrides;
 * `mergeConfigurations` decides which override wins.
 */
export const userOverridableConfigurationKeys = [
    "patientListEnabled",
];
/** Refuses a key a user may not override, rather than silently dropping it. */
export const UserOrganisationConfigurationSchema = z.partialRecord(z.enum(userOverridableConfigurationKeys), z.boolean().optional());
//# sourceMappingURL=configuration.js.map